/* eslint-disable sonarjs/no-duplicate-string */

/* cSpell:disable */
import React, { CSSProperties, useState } from 'react';

import CurrencyInput from 'react-currency-input-field';

import {
	Box,
	RoundButton,
	Spacer,
	TextBlock,
	TextBlockSizes,
	Typography,
	TypographyAppearance,
} from '@bcp-nextgen-dx-component-factory/design-system';
import { Check, Edit } from '@bcp-nextgen-dx-component-factory/icons-accolade';

import { SelectValueProps } from './selectValue';
import { useSelectValue } from './selectValue.helper';

// eslint-disable-next-line sonarjs/cognitive-complexity
export const SelectValueBcp: React.FC<SelectValueProps> = (props: SelectValueProps) => {
	const { defaultValues, value, disable, minValue, maxValue } = props;

	const {
		editingCustomValue,
		lastEditedValue,
		isValidCustomValue,
		handleOnChangeValue,
		handleSetCustomValue,
		handleCompleteEditing,
		handleMobileCompleteEditing,
		hideCustomValueErrorMessage,
		handleCustomInputChange,
		isCustomValue,
		handleOnEnterKey,
		currentView,
		translate,
		handleShowCustomValueErrorMessage,
		formatAmountNumber,
		getCurrencyDecimalSeparator,
		getCurrencyGroupSeparetor,
		hoveredElement,
		setHoveredElement,
		// hanldeOnOver,
		// isHover,
		isOtherValueHover,
		setIsOtherValueHover,
	} = useSelectValue(props);

	const selectValueStyles = {
		smallView: {
			card: { gap: '20px 12px', justifyContent: undefined },
			amountCard: {
				width: 'calc(50% - 6px)',
				widthEditing: 'calc(50% - 35px)',
				amountSize: 'small' as TextBlockSizes,
			},
			otherValue: {
				appearance: 'body-100-02' as TypographyAppearance,
			},
			currencyInput: {
				width: `${value.toString().length + 0.3}ch`,
			},
		},
		tabletView: {
			card: { gap: '24px 17px', justifyContent: undefined },
			amountCard: {
				width: 'calc(50% - 17px)',
				widthEditing: 'calc(50% - 35px)',
				amountSize: 'small' as TextBlockSizes,
			},
			otherValue: {
				appearance: 'subtitle-100-03' as TypographyAppearance,
			},
			currencyInput: {
				width: 'calc(100% - 13px)',
				textAlign: 'right',
			},
		},
		bigView: {
			card: { gap: '20px', justifyContent: 'space-between' },
			amountCard: {
				width: 'calc(33% - 17px)',
				widthEditing: 'calc(33% - 35px)',
				amountSize: 'medium' as TextBlockSizes,
			},
			otherValue: {
				appearance: 'subtitle-100-03' as TypographyAppearance,
			},
			currencyInput: {
				width: value >= 1000 ? `${value.toString().length + 1}ch` : `${value.toString().length}ch`,
				textAlign: 'right',
			},
		},
	};

	const inputView = () => (
		<>
			<CurrencyInput
				className="selectedCard"
				onValueChange={(e, a, value) => handleCustomInputChange(value?.float || 0)}
				onKeyDown={handleOnEnterKey}
				onPointerLeave={() => setIsOtherValueHover(false)}
				onBlur={handleMobileCompleteEditing}
				onFocus={hideCustomValueErrorMessage}
				value={value}
				maxLength={5}
				allowDecimals={false}
				allowNegativeValue={false}
				autoFocus={true}
				groupSeparator={getCurrencyGroupSeparetor()}
				decimalSeparator={getCurrencyDecimalSeparator()}
				style={
					{
						fontSize: '28px',
						color: value === 0 ? '#A5ACB7' : '#2E3641',
						background: 'transparent',
						fontWeight: '600',
						fontFamily: "'Montserrat',sans-serif",
						border: 'none',
						padding: 0,
						height: currentView === 'bigView' ? '72px' : '60px',
						outline: 'none',
						caretColor: '#D1005D',
						...selectValueStyles[currentView].currencyInput,
					} as CSSProperties
				}
			/>
			<Box
				styles={{
					justifyContent: 'center',
					flexDirection: 'column',
					marginTop: '4px',
					padding: currentView === 'smallView' ? '5px 0 0 5px' : '10px 0 0 5px',
				}}
			>
				<Typography
					appearance="microcopy-100-06"
					colorToken={value === 0 ? 'feedback-disabled-200' : 'primary-light'}
				>
					{'€'}
				</Typography>
			</Box>
		</>
	);

	return (
		<>
			<Box
				styles={{
					width: '100%',
					padding: '20px 0',
					flexWrap: 'wrap',
					...selectValueStyles[currentView].card,
				}}
			>
				{defaultValues?.length &&
					defaultValues.map((currentValue, i) => {
						const selected = value === currentValue;
						return (
							<div
								key={i}
								style={{
									...selectValueStyles[currentView].amountCard,
								}}
							>
								<button
									style={{
										WebkitTapHighlightColor: 'transparent',
										justifyContent: 'center',
										border: '1px solid #D7D9E0',
										borderRadius: '16px',
										cursor: 'pointer',
										height: currentView === 'bigView' ? '70px' : '62px',
										backgroundColor:
											selected && !editingCustomValue
												? '#2E3641'
												: hoveredElement === i
												? 'rgb(243, 244, 246)'
												: '#FFFFFF',
										outline: 'none',
										display: 'flex',
										width: '100%',
										transform: hoveredElement === i ? 'scale(1.05)' : 'scale(1)',
										transition: 'transform 0.3s',
										pointerEvents: disable ? 'none' : undefined,
										// ...selectValueStyles[currentView].amountCard,
									}}
									onClick={() => handleOnChangeValue(currentValue)}
									onPointerEnter={() => setHoveredElement(i)}
									onPointerLeave={() => setHoveredElement(undefined)}
									onFocus={() => setHoveredElement(i)}
									onBlur={() => setHoveredElement(undefined)}
									// onMouseEnter={() => hanldeOnOver(currentValue)}
								>
									<TextBlock.Currency
										size={`${selectValueStyles[currentView].amountCard.amountSize}`}
										hideCents
										floatValue={currentValue}
										variant={selected && !editingCustomValue ? 'dark' : 'light'}
										currency="€"
										fontWeight="semiStrong"
									/>
								</button>
							</div>
						);
					})}

				<Box
					styles={{
						// border: '1px solid',
						width: `${selectValueStyles[currentView].amountCard.width}`,
						flexDirection: 'column',
					}}
				>
					{!editingCustomValue && (
						<button
							style={{
								// border: '1px solid',
								// width: `${selectValueStyles[currentView].amountCard.width}`,
								width: '100%',
								pointerEvents: disable ? 'none' : undefined,
							}}
							onPointerEnter={() => setIsOtherValueHover(true)}
							onPointerLeave={() => setIsOtherValueHover(false)}
							onFocus={() => setIsOtherValueHover(true)}
							onBlur={() => setIsOtherValueHover(false)}
							onClick={() => handleSetCustomValue()}
						>
							<Box
								styles={{
									justifyContent: 'center',
									border: '1px solid #D7D9E0',
									borderRadius: '16px',
									cursor: 'pointer',
									height: currentView === 'bigView' ? '72px' : '64px',
									backgroundColor: isCustomValue
										? '#2E3641'
										: isOtherValueHover
										? 'rgb(243, 244, 246)'
										: '#FFFFFF',
									// transform: isOtherValueHover || isCustomValue ? 'scale(1.05)' : 'scale(1)',
									transform: isOtherValueHover ? 'scale(1.05)' : 'scale(1)',
									transition: 'transform 0.3s',
									// // width: '100%',
									// widthEditing: 'calc(33% - 35px)',
									// amountSize: 'small' as TextBlockSizes,
								}}
							>
								{isValidCustomValue && (
									<Box styles={{ alignItems: 'center' }}>
										<TextBlock.Currency
											size="small"
											hideCents
											floatValue={lastEditedValue}
											variant={isCustomValue ? 'dark' : 'light'}
											fontWeight="semiStrong"
										/>
										<Box
											styles={{
												justifyContent: currentView === 'smallView' ? 'end' : 'center',
												flexDirection: 'column',
												padding: '6px 5px 0px 0px',
												marginTop: '4px',
											}}
										>
											<Typography
												appearance="microcopy-100-06"
												colorToken={isCustomValue ? 'primary-dark' : 'primary-light'}
											>
												€
											</Typography>
										</Box>
										<Spacer horizontal={'2px'} />
										<Box
											styles={{
												justifyContent: 'center',
												flexDirection: 'column',
											}}
										>
											<Edit.Outline
												size={'xSmall'}
												fill={isCustomValue ? '#FFFFFF' : '#8694A7'}
											/>
										</Box>
									</Box>
								)}
								{!isValidCustomValue && (
									<Box styles={{ alignItems: 'center' }}>
										<TextBlock.Currency
											size="medium"
											hideCents
											floatValue={0}
											variant={isCustomValue ? 'dark' : 'light'}
											fontWeight="semiStrong"
											currency="€"
										/>

										<Box>
											<Edit size={'small'} fill={isCustomValue ? '#FFFFFF' : '#8694A7'} />
										</Box>
									</Box>
								)}
							</Box>
						</button>
					)}
					{editingCustomValue && (
						<Box
							styles={{
								justifyContent: 'center',
								border: handleShowCustomValueErrorMessage() ? '1px solid #E00E27' : '1px solid #2E3641',
								borderRadius: '16px',
								cursor: 'pointer',
								// // width: `${selectValueStyles[currentView].amountCard.widthEditing}`,
								// width: '100%',
								padding: '0px 6px',
								background: '#FFFFFF',
								transform: isOtherValueHover || isCustomValue ? 'scale(1.05)' : 'scale(1)',
								transition: 'transform 0.3s',
							}}
						>
							{/* {currentView === 'bigView' || currentView === 'tabletView' ? (
							<Box styles={{ width: '60%' }}>{inputView()}</Box>
						) : (
							inputView()
						)} */}
							{inputView()}
							{isValidCustomValue && (
								<Box
									styles={
										{
											// width: '40%',
											// flexDirection: 'column',
											// justifyContent: 'center'
										}
									}
								>
									<Box
										styles={{
											// width: '100%',
											// height: '30px',
											// justifyContent: 'center',
											marginLeft: '6px',
										}}
									>
										<RoundButton
											icon={{ source: Check.Outline }}
											size="small"
											onPress={handleCompleteEditing}
											disabled={!isValidCustomValue}
										/>
									</Box>
								</Box>
							)}
						</Box>
					)}

					{handleShowCustomValueErrorMessage() && (
						<Box
							styles={{
								color: '#D0021B',
								marginTop: '7px',
								fontFamily: "'Montserrat',sans-serif",
								fontWeight: 500,
								fontSize: 13,
							}}
						>
							{translate('simulator.dataInput.enterAmountBetweenXandY', {
								minAmount: formatAmountNumber(minValue),
								maxAmount: formatAmountNumber(maxValue),
							})}
						</Box>
					)}
				</Box>
			</Box>
		</>
	);
};
/* cSpell:enable */
